import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listSupportAccounts } from "../../api/support";
import { useAuth } from "../../auth";

export default function Support() {
  const navigate = useNavigate();
  const { beginSupport, supportAvailable } = useAuth();
  const [query, setQuery] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = async (value = query) => {
    setLoading(true);
    setError("");
    try {
      const response = await listSupportAccounts(value);
      setAccounts(response?.result || []);
    } catch (err) {
      setError(err?.message || "Unable to load accounts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (supportAvailable) load(""); }, [supportAvailable]);

  if (!supportAvailable) return <p>Super-admin access is required.</p>;

  return (
    <section>
      <h1>Support accounts</h1>
      <p className="text-muted">Select an account to manage normal content, leads, images, and website settings.</p>
      <form className="d-flex gap-2 mb-4" onSubmit={(event) => { event.preventDefault(); load(query); }}>
        <input className="form-control" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Company, domain, or owner email" />
        <button className="btn btn-primary" type="submit">Search</button>
      </form>
      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? <p>Loading accounts…</p> : (
        <div className="list-group">
          {accounts.map(account => (
            <div key={account.id} className="list-group-item d-flex justify-content-between align-items-center gap-3">
              <div>
                <strong>{account.companyName || account.domain || account.id}</strong>
                <div className="small text-muted">{[account.domain, account.ownerEmail, account.planName].filter(Boolean).join(" · ")}</div>
              </div>
              <button className="btn btn-outline-primary" onClick={async () => { await beginSupport(account.id); navigate("/posts/profile"); }}>
                Access account
              </button>
            </div>
          ))}
          {!accounts.length && <p>No matching accounts.</p>}
        </div>
      )}
    </section>
  );
}
